import { render, staticRenderFns } from "./EntregaOnlineView.vue?vue&type=template&id=2739302b&"
import script from "./EntregaOnlineView.vue?vue&type=script&lang=js&"
export * from "./EntregaOnlineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports